import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';
import type { Locales } from 'cms/cms-types';
import React from 'react';

// import type { OptionTypeBase } from 'react-select';
export const VIEW_MAP = 'map';
export const VIEW_LISTING = 'listing';

export interface AssetsListingCMSConfig {
    apiKey: string;
}

export interface Coordinates {
    lat: number;
    lon: number;
}

export interface AssetsListingMap {
    apiKey: string;
    mapId: string;
    filters?: Filter[];
    filterByAncestors?: string[];
    showInactiveItems?: boolean;
}

interface AssetsMapCardLabel {
    sectorLabel: string;
    assetTypeLabel: string;
    countriesLabel: string;
}

export interface AssetsListingBaseLabel extends ListingUILabel {
    title: string;
    mapViewSwitchTitle: string;
    listViewSwitchTitle: string;
    filterHeading: string;
    clearFilterButton: string;
    applyFilterButton: string;
    filterModalButton: string;
    filterModalHeading: string;
    readMoreCardLabel: string;
}

interface AssetsListingLabel extends AssetsListingBaseLabel, AssetsMapCardLabel {}

export interface AssetsListingListing {
    filters?: Filter[];
    filterByAncestors?: string[];
    itemsPerPage: number;
}

export interface AssetsListingProps {
    cms: AssetsListingCMSConfig;
    locale?: Locales;
    label: AssetsListingLabel;
    map: AssetsListingMap;
    listing: AssetsListingListing;
}

export type AssetsListingView = typeof VIEW_MAP | typeof VIEW_LISTING;

export interface AssetsListingContextProps extends AssetsListingProps, ListingFiltersState {
    view: AssetsListingView;
    setView: React.Dispatch<React.SetStateAction<AssetsListingView>>;
    activeItemId: string;
    setActiveItemId: React.Dispatch<React.SetStateAction<string>>;
    filterModalOpen: boolean;
    setFilterModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
}

const AssetsListingContext = React.createContext<Partial<AssetsListingContextProps>>({});

export default AssetsListingContext;
